import {
  FaTachometerAlt,
  FaUsers,
  FaDollarSign,
  FaRegQuestionCircle,
  FaCog,
  FaChartLine,
  FaMoneyBillWave,
} from "react-icons/fa";
import { GoAlertFill } from "react-icons/go";
import { FaVideo, FaFolder, FaEnvelopeOpenText } from "react-icons/fa6";
import { LuActivity } from "react-icons/lu";
import { AiFillProduct } from "react-icons/ai";
import { MdCategory } from "react-icons/md";
import { FaFilePdf } from "react-icons/fa";

export const menuConfig = [
  // --- Admin Specific ---
  {
    title: "Admin Dashboard",
    icon: FaTachometerAlt,
    path: "/admin",
    roles: ["Admin"],
  },

  {
    title: "Management Users",
    icon: FaUsers,
    path: "/admin/users",
    roles: ["Admin"],
  },

  {
    title: "Manage Subscriptions",
    icon: FaEnvelopeOpenText,
    path: "/admin/subscriptions",
    roles: ["Admin"],
  },

  {
    title: "Transactions Table",
    icon: FaMoneyBillWave,
    path: "/admin/transactions",
    roles: ["Admin"],
  },

  {
    title: "Manage Videos",
    icon: FaVideo,
    roles: ["Admin"],
    items: [
      { label: "Videos", path: "/admin/videos" },
      { label: "Add Video", path: "/admin/videos/add-video" },
    ],
  },

  {
    title: "Manage Plans",
    icon: FaFilePdf,
    roles: ["Admin"],
    items: [
      { label: "Plans", path: "/admin/plans" },
      { label: "Add Plan", path: "/admin/plans/add-plan" },
    ],
  },

  {
    title: "Video Categories",
    icon: MdCategory,
    roles: ["Admin"],
    items: [
      { label: "Video Categories", path: "/admin/categories" },
      { label: "Add Video Category", path: "/admin/categories/add-category" },
    ],
  },

  {
    title: "Manage Products",
    icon: AiFillProduct,
    roles: ["Admin"],
    items: [
      { label: "WooCommerce", path: "/admin/products/woo-products" },
      { label: "Products", path: "/admin/products" },
      { label: "Add Product", path: "/admin/products/add-product" },
    ],
  },

  {
    title: "Alerts",
    icon: GoAlertFill,
    path: "/admin/alerts",
    roles: ["Admin"],
  },

  {
    title: "Activity Log",
    icon: LuActivity,
    path: "/admin/activities",
    roles: ["Admin"],
  },

  {
    title: "About",
    icon: LuActivity,
    path: "/admin/about",
    roles: ["Admin"],
  },

  {
    title: "Faqs",
    icon: AiFillProduct,
    roles: ["Admin"],
    items: [
      { label: "faqs", path: "/admin/faqs" },
      { label: "Add Faq", path: "/admin/faqs/addfaq" },
    ],
  },

  {
    title: "Settings (Admin)",
    icon: FaCog,
    roles: ["Admin"],
    items: [
      { label: "General Settings", path: "/admin/settings/general" },
      { label: "API Keys", path: "/admin/settings/api-keys" },
      { label: "Email Templates", path: "/admin/settings/email-templates" },
      { label: "System Logs", path: "/admin/settings/logs" },
    ],
  },

  // --- Client Specific ---
  {
    title: "User Dashboard",
    icon: FaTachometerAlt,
    path: "/client-portal/dashboard",
    roles: ["User"], // Only visible to Clients
  },
  {
    title: "Requests & Support",
    icon: FaRegQuestionCircle,
    path: "/client/support",
    roles: ["User", "Employee"], // Clients can submit, employees can respond
  },
  {
    title: "Subscription",
    icon: FaDollarSign,
    path: "/client/subscription",
    roles: ["User"],
  },
  {
    title: "Payment Settings",
    icon: FaCog,
    path: "/client-portal/payment-settings",
    roles: ["User"], // Client here implies the primary client user
    companyRoles: ["primary"], // Further restriction: only primary client user
  },
];
